var r=function(r,a){for(var e={},t=Object.keys(r),n=Array.isArray(a),f=0;f<t.length;f++){var i=t[f],o=r[i];(n?-1!==a.indexOf(i):a(i,o,r))&&(e[i]=o)}return e};export{r as default};
